// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"Menu_menuItem__2uFdv","submenu":"Menu_submenu__3cyRl"};